import {Component, HostBinding, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {NavBarObject} from '../../../_components/nav-bar/config';
import {Periodo} from '../../../_models/interfaces';


@Component({
  templateUrl: 'mapa-curricular-busqueda.component.html',
  standalone: false,
  // tslint:disable-next-line: no-host-metadata-property
  host: {
    class: 'search-box'
  },
  styleUrls: ['./mapa-curricular.component.scss']
})
export class MapaCurricularBusquedaComponent implements OnInit {

  searchTerm;
  idsMateria;
  idsCurso;
  getUnidades: number;

  paramsForm: UntypedFormGroup;

  cursos: any[];
  areas: any[];

  constructor(private router: Router, private route: ActivatedRoute, private fb: UntypedFormBuilder) {
  }

  ngOnInit() {
    this.buildForm();
    this.route.parent.data.subscribe((data: { cursos: any[] }) => {
      this.cursos = data.cursos;
    });
    this.route.parent.data.subscribe((data: { areas: any[] }) => {
      this.areas = data.areas;
    });
  }

  buildForm() {
    this.searchTerm = this.route.snapshot.paramMap.get('termino') != null ?
      this.route.snapshot.paramMap.get('termino') : '';
    this.idsMateria = this.route.parent.snapshot.paramMap.get('idsMateria') != null
      ? this.route.parent.snapshot.paramMap.get('idsMateria').split(',') : '';
    this.idsCurso = this.route.parent.snapshot.paramMap.get('idsCurso') != null
      ? this.route.parent.snapshot.paramMap.get('idsCurso').split(',') : '';


    this.paramsForm = this.fb.group({
      termino: [this.searchTerm],
      idsMateria: [this.idsMateria],
      idsCurso: [this.idsCurso]
    });
  }

  realizarBusqueda() {
    const termino = this.paramsForm.value.termino,
      idsMateria = this.paramsForm.value.idsMateria.length > 0 ? this.paramsForm.value.idsMateria.toString() : '0',
      idsCurso = this.paramsForm.value.idsCurso.length > 0 ? this.paramsForm.value.idsCurso.toString() : '0',
      getUnidades = this.paramsForm.value.getUnidades ? '1' : '0',
      url = `/estudio/mapa-curricular/materias/${idsMateria}/cursos/${idsCurso}`;

    // this.router.navigateByUrl(url);
    window.location.href = url;
    // this.router.navigate(['estudio', 'mapa-curricular','26', '10', 1, {outlets: {'mc-sidebar': null}}]);
  }

  cerrar(evt) {
    evt.preventDefault();
    this.router.navigate([{outlets: {'mc-sidebar': null}}], {
      skipLocationChange: true,
      relativeTo: this.route.parent
    });
  }
}
